/// <amd-module name="Pipeline/Analytics/PipelineOutcome/FailureTrendCard/Stores/PipelineOutcomeFailureTrendStore" />
import { getPercentage } from "Analytics/Shared/Utils/Number";
import { IPipelineReportBaseState, PipelineReportBaseStore } from "Pipeline/Analytics/Common/Stores/PipelineReportBaseStore";
import { IPipelineOutcomeData } from "Pipeline/Analytics/Common/Types";
import { ITopFailingStageAndTaskData } from "Pipeline/Analytics/Common/Types";
import { PipelineOutcomeFailureTrendActions } from "Pipeline/Analytics/PipelineOutcome/FailureTrendCard/Actions/PipelineOutcomeFailureTrendActions";

export interface IPipelineOutcomeFailureTrendState extends IPipelineReportBaseState<IPipelineOutcomeData> {
    topFailingStageAndTask: ITopFailingStageAndTaskData;
    topFailingTaskPercentage: number | 0;
}

export class PipelineOutcomeFailureTrendStore extends PipelineReportBaseStore<
    PipelineOutcomeFailureTrendActions,
    IPipelineOutcomeFailureTrendState,
    IPipelineOutcomeData
> {
    constructor(public _actions: PipelineOutcomeFailureTrendActions) {
        super(_actions);
        this.initializeListener();
    }

    public dispose(): void {
        this._actions.updateFailingStageAndTaskDataAction.removeListener(this._onUpdateFailingTaskData);
        super.dispose();
    }

    protected initializeListener(): void {
        this._actions.updateFailingStageAndTaskDataAction.addListener(this._onUpdateFailingTaskData);
    }

    protected _onUpdateFailingTaskData = (_data: ITopFailingStageAndTaskData) => {
        if (_data) {
            this._state.errorText = undefined;
            this._state.topFailingStageAndTask = _data;
            this._state.topFailingTaskPercentage = getPercentage(_data.stageFailureCount, _data.failedCount);
            this.emitChanged();
        }
    };
}
